import { render, staticRenderFns } from "./UserTableItems.vue?vue&type=template&id=2886ac34&"
import script from "./UserTableItems.vue?vue&type=script&lang=js&"
export * from "./UserTableItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports